if (!customElements.get('ol-floor-volume')) customElements.define('ol-floor-volume', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse(this.querySelector('script').textContent);
    this.form = document.getElementById(this.dataset.form);
    if (!this.form) return;
    this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
    this.update = () => {
      const quantity = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
      const totalQuantity = quantity + this.data.cartQuantity;
      const rate = Number.isInteger(totalQuantity) && totalQuantity >= 25 ? 8 : totalQuantity >= 10 ? 5 : totalQuantity >= 5 ? 3 : 0;
      const variant = this.data.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]')?.value);
      const valid = variant && Number.isInteger(quantity) && quantity > 0;
      this.querySelector('[data-volume-price]').hidden = !valid || !rate;
      for (const tier of this.querySelectorAll('[data-rate]')) tier.classList.toggle('is-active', Number(tier.dataset.rate) === rate);
      if (!valid) return;
      const cents = variant.price - Math.floor(variant.price * rate / 100);
      this.querySelector('[data-unit]').textContent = this.money.format(cents / 100);
      this.querySelector('[data-total]').textContent = this.money.format(cents * quantity / 100);
    };
    this.form.addEventListener('input', this.update);
    this.form.addEventListener('change', this.update);
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener('on:variant:change', this.update);
    this.update();
  }
});
